import Thunk, { ThunkConfig } from 'src/thunks/index';
import { Data } from 'src/interfaces/general';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import notification from 'src/store/ui/notification';

export const endpoint = 'coupons';
const coupon = new Thunk(endpoint);

export interface ValidCoupon {
  id: string;
  user_id: string;
  code: string;
  percent_off: number;
  amount_off: number;
  max_discount_amount: number;
  expired_at: string | null;
  created_at: string;
  updated_at: string;
  discount_amount: number;
}

export const fetchCouponDetail = coupon.fetchOne<Data<Model.Coupon>>({});

export interface ValidateCouponCode {
  class_price_id?: string;
  coupon_code: string;
}

export const validateCouponCode = createAsyncThunk<
  Data<ValidCoupon>,
  ValidateCouponCode,
  ThunkConfig
>('validate_coupon', async (args, { dispatch, rejectWithValue }) => {
  try {
    const { data } = await coupon.post(`coupons/${args.coupon_code}/validate`, {
      class_price_id: args.class_price_id,
    });

    return data.data;
  } catch (err) {
    const error = err as unknown as AxiosError;

    dispatch(
      notification.on({
        type: 'error',
        message: error.response?.data?.message || 'An error occurred',
      }),
    );

    return rejectWithValue(error);
  }
});

export interface ValidateCouponId {
  class_price_id?: string;
  coupon_id: string;
}

export const validateCouponId = createAsyncThunk<
  Data<ValidCoupon>,
  ValidateCouponId,
  ThunkConfig
>('validate_coupon', async (args, { dispatch, rejectWithValue }) => {
  try {
    const { data } = await coupon.post(`coupons/${args.coupon_id}/validate`, {
      class_price_id: args.class_price_id,
    });

    return data.data;
  } catch (err) {
    const error = err as unknown as AxiosError;

    dispatch(
      notification.on({
        type: 'error',
        message: error.response?.data?.message || 'An error occurred',
      }),
    );

    return rejectWithValue(error);
  }
});
